import API from 'shared/api/API';
import { GET } from 'shared/utils/Executer';

class KnowledgeAPI {
  /**
   * Get all knowledge items for the current user's organization and workspaces
   * Note: This endpoint uses the user's organizationId and workspaces from their JWT token
   * @param {Object} [params] - Query parameters
   * @param {number} [params.page=1] - Page number
   * @param {number} [params.limit=20] - Items per page
   * @param {string} [params.workspaceId] - Optional workspace filter
   * @returns {Promise<Object>} Knowledge items with pagination
   */
  async getKnowledgeItems(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.workspaceId) queryParams.append('workspaceId', params.workspaceId);

    const queryString = queryParams.toString();
    const url = `/v1/knowledge${queryString ? `?${queryString}` : ''}`;

    return await API.client.execute(GET, url);
  }

  /**
   * Get the knowledge items count for stats, counted server-side.
   * @returns {Promise<Object>} One-item catalog page carrying `total`
   */
  async getKnowledgeItemsCount() {
    return await API.client.execute(GET, '/v1/knowledge/items/page?pageSize=1&includeTotal=true');
  }
}

export default new KnowledgeAPI();
